import React from "react";
import "echarts-gl";
import ReactEcharts from "echarts-for-react";

const COLOR_MAP = {
  thickness: [
    "#0000FF",
    "#0033FF",
    "#0066FF",
    "#0099FF",
    "#00CCFF",
    "#00FFFF",
    "#00FFCC",
    "#00FF99",
    "#00FF66",
    "#00FF33",
    "#00FF00",
    "#33FF00",
    "#66FF00",
    "#99FF00",
    "#CCFF00",
    "#FFFF00",
    "#FFCC00",
    "#FF9900",
    "#FF6600",
    "#FF3300",
    "#FF0000",
  ],
  concentration: [
    "#0000FF",
    "#0033FF",
    "#0066FF",
    "#0099FF",
    "#00CCFF",
    "#00FFFF",
    "#00FFCC",
    "#00FF99",
    "#00FF66",
    "#00FF33",
    "#00FF00",
    "#33FF00",
    "#66FF00",
    "#99FF00",
    "#CCFF00",
    "#FFFF00",
    "#FFCC00",
    "#FF9900",
    "#FF6600",
    "#FF3300",
    "#FF0000",
  ],
  rv: [
    "#FF0000",
    "#FF3300",
    "#FF6600",
    "#FF9900",
    "#FFCC00",
    "#FFFF00",
    "#CCFF00",
    "#99FF00",
    "#66FF00",
    "#33FF00",
    "#00FF00",
    "#00FF33",
    "#00FF66",
    "#00FF99",
    "#00FFCC",
    "#00FFFF",
    "#00CCFF",
    "#0099FF",
    "#0066FF",
    "#0033FF",
    "#0000FF",
  ],
};

function RouteFactorChart({ data, points, type }) {
  return (
    <ReactEcharts
      option={{
        tooltip: {},
        legend: {
          show: false,
        },
        visualMap: {
          show: false,
          dimension: 2,
          min: 0,
          max: 30,
          inRange: {
            color: COLOR_MAP[type],
          },
        },
        xAxis3D: {
          type: "value",
          name: "",
          axisLabel: {
            color: "rgba(255,255,255,0.75)",
            fontSize: 12,
            lineHeight: 16,
            end: true,
            margin: 12,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(255, 255, 255, 0.75)",
            },
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: "rgba(255, 255, 255, 0.75)",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(255, 255, 255, 0.35)",
            },
          },
        },
        yAxis3D: {
          type: "value",
          name: "",
          axisLabel: {
            color: "rgba(255,255,255,0.75)",
            fontSize: 12,
            lineHeight: 16,
            end: true,
            margin: 12,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(255, 255, 255, 0.75)",
            },
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: "rgba(255, 255, 255, 0.75)",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(255, 255, 255, 0.35)",
            },
          },
        },
        zAxis3D: {
          type: "value",
          name: "",
          axisLabel: {
            color: "rgba(255,255,255,0.75)",
            fontSize: 12,
            lineHeight: 16,
            end: true,
            margin: 20,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(255, 255, 255, 0.75)",
            },
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: "rgba(255, 255, 255, 0.75)",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(255, 255, 255, 0.35)",
            },
          },
        },
        grid3D: {
          viewControl: {
            projection: "orthographic",
          },
          // boxWidth: 100,
          // boxDepth: 100,
          // boxHeight: 100,
          top: 5,
          right: 5,
          left: 10,
          bottom: 5,
        },
        series: [
          {
            type: "line3D",
            data: data,
            lineStyle: { width: 5 },
          },
          {
            type: "scatter3D",
            name: "Point",
            itemStyle: {
              color: "rgb(116,173,209)",
            },
            label: {
              show: true,
              position: "top",
              distance: 1,
              color: "rgb(255,255, 255, 0.75)",
              fontSize: 14,
              borderWidth: 0,
              borderColor: "#313695",
              backgroundColor: "transparent",
            },
            data: points,
          },
        ],
      }}
      style={{ height: "100%", width: "100%" }}
    />
  );
}

export default RouteFactorChart;
